/**
 * Compact player avatar — colour dot + nickname.
 */
export default function PlayerAvatar({ nickname, colour, size = 'md', showName = true, className = '' }) {
  const dotSize = size === 'sm' ? 'w-2.5 h-2.5' : size === 'lg' ? 'w-4 h-4' : 'w-3 h-3';
  const textSize = size === 'sm' ? 'text-xs' : size === 'lg' ? 'text-base' : 'text-sm';

  return (
    <div className={`flex items-center gap-1.5 ${className}`}>
      <div
        className={`${dotSize} rounded-full shrink-0`}
        style={{ backgroundColor: colour || '#94A3B8' }}
      />
      {showName && (
        <span className={`${textSize} text-charcoal font-display truncate`}>
          {nickname || 'Unknown'}
        </span>
      )}
    </div>
  );
}
